/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx } from '@emotion/react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Col, Row, Container } from 'react-bootstrap'
import { Form as BootstrapForm } from 'react-bootstrap'
import AdminMainLayout from './AdminMainLayout'
import BusyMask from '../../components/BusyMask'
import Card from '../../components/layout/Card'
import { Separator } from '../../components/layout/Separator'
import { BlueButton } from '../../components/layout/BlueButton'
import { Error } from '../../components/layout/Error'
import Loading from '../../components/Loading'
import { FormikInputField } from '../../components/form/InputField'
import { FormikGeneralFormErrors } from '../../components/form/GeneralFormErrors'
import { handleSubmitResult } from '../../actions/form'
import { showSuccess } from '../../actions/Error'
import { globalSettingsList } from '../../actions/settings'
import { adminManualEditableEmailCreateList, adminManualEditableEmailList } from '../actions/admin_editable_email'

const validationSchema = Yup.object().shape({
    'name': Yup.string().required("Required")
})

class AdminManualEditableEmailCreate extends Component {

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(globalSettingsList.ensureGlobalSettingsLoaded())
    }

    onSave = (values, formik_funcs) => {
        const { history, dispatch } = this.props

        const on_ok = function() {
            // Go back to the list rather than dropping straight into the editor. The new rows sort to
            // the top (the list is ordered by most recently modified), so it is clear what to do next.
            dispatch(adminManualEditableEmailList.invalidateList())
            showSuccess("Created", "Email created")
            history.push('/admin/manual_editable_emails/')
        }

        return dispatch(adminManualEditableEmailCreateList.saveNewObject({name: values.name}))
                 .then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
    }

    render() {
        const { is_busy, is_loading, can_edit } = this.props
        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           {name: 'manual_editable_emails',
                                            label: 'Manual Emails',
                                            url: '/admin/manual_editable_emails'},
                                           {name: 'manual_editable_email',
                                            label: 'New email',
                                            url: '/admin/manual_editable_email/'}
                                          ]}>
              <Container fluid>
                { is_busy && <BusyMask /> }
                { is_loading && <Loading /> }
                <h1>Create new email</h1>
                <Separator variant="h30" />

                <Formik
                  initialValues={{name: ''}}
                  onSubmit={this.onSave}
                  validationSchema={validationSchema}
                >
                  {formik_props => {
                      return (
                          <Form>
                            <FormikGeneralFormErrors render={(msg) => <Row><Col>{msg}</Col></Row>} />
                            <Row>
                              <Col>
                                <Card>
                                  <BootstrapForm.Group>
                                    <BootstrapForm.Label>Name</BootstrapForm.Label>
                                    <FormikInputField name="name" placeholder="Name" />
                                  </BootstrapForm.Group>

                                  <p>
                                    An email will be created for each language, ready for you to write.
                                  </p>

                                  { can_edit &&
                                    <BlueButton type="submit">Create email</BlueButton>
                                  }
                                  { ! can_edit &&
                                    <Error>Editing custom emails is disabled</Error>
                                  }
                                </Card>
                              </Col>
                            </Row>
                          </Form>
                      )
                  }}
                </Formik>
              </Container>
            </AdminMainLayout>
        )
    }

}

function mapStateToProps(state, props) {
    return {
        is_busy: adminManualEditableEmailCreateList.getIsSavingObject(),
        is_loading: globalSettingsList.isLoading(),
        can_edit: globalSettingsList.getSetting('can_edit_editable_emails'),
    }
}

export default connect(mapStateToProps)(AdminManualEditableEmailCreate)
